/* Start - ADA fix for sign up email form for WBC */



document.addEventListener("DOMContentLoaded", function () {

  function applyAriaFix() {
    // Target the SUCCESS message wrapper (it always contains these IDs)
    const successMessage = document.querySelector(
      '#rich-text-01JP5SHWR82DZCV3139DQE1TGB, ' +
      '#rich-text-01JP5SHWR49TMTDTEHNS3WDZQ9'
    );

    if (!successMessage) return;

    // Apply role + aria attributes to the block wrapper
    const wrapper = successMessage.closest('[data-testid="form-component"]');
    if (!wrapper) return;

    wrapper.setAttribute("role", "status");
    wrapper.setAttribute("aria-live", "polite");
    wrapper.setAttribute("aria-atomic", "true");

    console.log("ADA live region fix applied to Klaviyo Success Message");
  }

  // Watch the entire document for when Klaviyo replaces the form with success message
  const observer = new MutationObserver(() => {
    applyAriaFix();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

});



/* End  - ADA fix for sign up email form for WBC */


/* Start - ADA fix team sider didn't scal on zoom with mobile */



  (function () {
    function initSliderZoomFix() {
      var container = document.getElementById('rev_slider_2_1_forcefullwidth');
      var wrap      = document.getElementById('rev_slider_2_1_wrapper');
      if (!container || !wrap) return;

      // Use the initial rendered size as our "design" size
      var baseWidth  = wrap.offsetWidth || 1;
      var baseHeight = wrap.offsetHeight || 1;

      function scaleSlider() {
        var available = container.clientWidth || window.innerWidth;
        var scale = available / baseWidth;

        // Don't upscale on big screens, only shrink
        if (scale > 1) scale = 1;

        wrap.style.transform = 'scale(' + scale + ')';
        // Adjust container height so layout stays correct
        container.style.height = (baseHeight * scale) + 'px';
      }

      // Initial run + keep it updated on resize/zoom changes
      scaleSlider();
      window.addEventListener('resize', scaleSlider);
      window.addEventListener('orientationchange', scaleSlider);
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(initSliderZoomFix, 500);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(initSliderZoomFix, 500);
      });
    }
  })();



/* End - ADA fix team sider didn't scal on zoom with mobile */





/* Start - ADA fix Nav menu fixes  */



  (function () {
    function fixTopMenuAccessibility() {
      // All qikify menu links (desktop + mobile)
      var menuLinks = document.querySelectorAll('.tmenu_item_link');

      menuLinks.forEach(function (link) {
        // 1) Remove any aria-label from the <a>
        if (link.hasAttribute('aria-label')) {
          link.removeAttribute('aria-label');
        }

        // 2) Hide decorative chevron SVGs inside the indicator
        var chevronSvgs = link.querySelectorAll('.tmenu_indicator_icon svg');
        chevronSvgs.forEach(function (svg) {
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('focusable', 'false');
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixTopMenuAccessibility);
    } else {
      fixTopMenuAccessibility();
    }
  })();


document.addEventListener("DOMContentLoaded", function () {
  // Select all qikify menu links
  var links = document.querySelectorAll('.tmenu_item_link');

  links.forEach(function (link) {
    if (link.hasAttribute('aria-label')) {
      link.removeAttribute('aria-label');
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  // Remove unwanted aria-labels
  document.querySelectorAll('.tmenu_item_link[aria-label]').forEach(function (link) {
    link.removeAttribute('aria-label');
  });

  // Add aria-hidden to menu chevron SVGs
  document.querySelectorAll('.tmenu_indicator_icon svg').forEach(function (svg) {
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
  });
});


document.addEventListener("DOMContentLoaded", function () {
  // Remove bad aria-labels that Qikify injected
  document.querySelectorAll('.tmenu_item_link[aria-label]')
    .forEach(function (el) {
      el.removeAttribute('aria-label');
    });
});


document.addEventListener("DOMContentLoaded", function () {
  // Desktop root menu items (SHOP / ABOUT / SAFETY)
  var desktopRootButtons = document.querySelectorAll(
    '.tmenu_app_desktop .tmenu_item_has_child > .tmenu_item_link'
  );

  desktopRootButtons.forEach(function (btn) {
    // Kill junk aria-label like "to activate press enter"
    if (btn.hasAttribute('aria-label')) {
      btn.removeAttribute('aria-label');
    }

    // Mark as a popup trigger
    btn.setAttribute('aria-haspopup', 'true');

    // If Qikify didn't set aria-expanded, default to false
    if (!btn.hasAttribute('aria-expanded')) {
      btn.setAttribute('aria-expanded', 'false');
    }

    // Toggle aria-expanded on click (for keyboard / mouse users)
    btn.addEventListener('click', function () {
      var isExpanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    });
  });

  // (Optional) Do the same for mobile drawer menu items
  var mobileRootButtons = document.querySelectorAll(
    '.tmenu_app_mobile .tmenu_item_has_child > .tmenu_item_link'
  );

  mobileRootButtons.forEach(function (btn) {
    if (btn.hasAttribute('aria-label')) {
      btn.removeAttribute('aria-label');
    }

    btn.setAttribute('aria-haspopup', 'true');

    if (!btn.hasAttribute('aria-expanded')) {
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function () {
      var isExpanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    });
  });
}); // CLOSES the DOMContentLoaded wrapper



/* End - ADA fix Nav menu fixes  */





/* Start - ADA fix Yotpo reviews on product page*/

(function () {
  var MAX_TRIES = 20;
  var tries = 0;

  /**
   * Utility: run a function once DOM is ready
   */
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /**
   * Core fixer: apply all ADA tweaks inside Yotpo widgets
   */
  function fixYotpoAccessibility(root) {
    root = root || document;

    // Work on each Yotpo widget we find
    var widgets = root.querySelectorAll('.yotpo-main-widget, #yotpoMainWidgetCartridge');
    if (!widgets.length) return;

    widgets.forEach(function (widget) {
      // --- 1) "Powered by Yotpo" link aria-label ---
      var poweredLinks = widget.querySelectorAll('.yotpo-logo-link-new');
      poweredLinks.forEach(function (link) {
        if (link.dataset.adaPoweredFixed === 'true') return;
        link.setAttribute('aria-label', 'Powered by Yotpo');
        link.dataset.adaPoweredFixed = 'true';
      });

      // --- 2) Pagination aria-labels + roles ---
      var pageLinks = widget.querySelectorAll('.yotpo-pager .yotpo-page-element.goTo');
      pageLinks.forEach(function (link) {
        var page = link.getAttribute('data-page') || link.textContent.trim();
        if (!page) return;

        var isCurrent =
          link.classList.contains('yotpo-active') ||
          link.getAttribute('aria-current') === 'true' ||
          link.getAttribute('aria-current') === 'page';

        if (isCurrent) {
          link.setAttribute('aria-current', 'page');
          link.setAttribute('aria-label', 'Page ' + page + ', Current Page');
        } else {
          link.removeAttribute('aria-current');
          link.setAttribute('aria-label', 'Go to Page ' + page);
        }

        if (!link.hasAttribute('role')) {
          link.setAttribute('role', 'menuitem');
        }
      });

      // --- 3) Remove bogus heading roles from "Verified Buyer" etc. ---
      var badHeadings = widget.querySelectorAll(
        '[role="heading"].yotpo-user-title, ' +
        '.yotpo-user-title[role="heading"], ' +
        '.label-with-tooltip [role="heading"]'
      );
      badHeadings.forEach(function (el) {
        el.removeAttribute('role');
        el.removeAttribute('aria-level');
      });

      // --- 4) Make error boxes polite live regions ---
      var errorBoxes = widget.querySelectorAll('.error-box');
      errorBoxes.forEach(function (box) {
        box.setAttribute('aria-live', 'polite');
      });

      // --- 5) Ensure read-more / read-less labels are actually read ---
      var readMoreLabels = widget.querySelectorAll(
        '.sr-only[id$="-read-more"], .sr-only[id$="-read-less"]'
      );
      readMoreLabels.forEach(function (label) {
        if (label.hasAttribute('aria-hidden')) {
          label.removeAttribute('aria-hidden');
        }
      });

      // --- 6) Make sure star rating containers are not aria-hidden ---
      var starWrappers = widget.querySelectorAll('.yotpo-stars[aria-hidden="true"]');
      starWrappers.forEach(function (stars) {
        stars.removeAttribute('aria-hidden');
      });

      // --- 7) Treat "Read More" controls as real buttons for keyboard / SR ---
      var readMoreButtons = widget.querySelectorAll('.yotpo-read-more');
      readMoreButtons.forEach(function (btn) {
        if (!btn.hasAttribute('role')) {
          btn.setAttribute('role', 'button');
        }
        if (!btn.hasAttribute('tabindex')) {
          btn.setAttribute('tabindex', '0');
        }
        // Yotpo manages aria-expanded; we leave that logic alone.
      });

      // --- 8) Descriptive aria-labels for star-distribution review counts ---
      // e.g. "(15)" -> aria-label="5 out of 5 star rating with 15 reviews"
      var distButtons = widget.querySelectorAll(
        '.yotpo-star-distribution .yotpo-distibutions-sum-reviews .yotpo-sum-reviews[data-score-distribution]'
      );

      distButtons.forEach(function (btn) {
        var score = btn.getAttribute('data-score-distribution');
        if (!score) return;

        var countText = btn.textContent || '';
        var match = countText.match(/\d+/);
        var count = match ? parseInt(match[0], 10) : 0;

        if (isNaN(count)) return;

        var reviewWord = count === 1 ? 'review' : 'reviews';
        var label =
          score + ' out of 5 star rating with ' + count + ' ' + reviewWord;

        btn.setAttribute('aria-label', label);

        // Ensure these act like buttons for AT
        if (!btn.hasAttribute('role')) {
          btn.setAttribute('role', 'button');
        }
        if (!btn.hasAttribute('tabindex')) {
          btn.setAttribute('tabindex', '0');
        }
      });
    });
  }

  /**
   * Initial run on DOM ready
   */
  onReady(function () {
    // First pass
    fixYotpoAccessibility(document);

    // Short-lived poller for async Yotpo rendering
    var poller = setInterval(function () {
      tries += 1;
      fixYotpoAccessibility(document);
      if (tries >= MAX_TRIES) {
        clearInterval(poller);
      }
    }, 500);

    // Watch for Yotpo widgets being injected / updated
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      var shouldRun = false;

      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (!(node instanceof HTMLElement)) continue;

            if (
              node.classList.contains('yotpo-main-widget') ||
              node.id === 'yotpoMainWidgetCartridge' ||
              node.querySelector &&
              node.querySelector('.yotpo-main-widget, #yotpoMainWidgetCartridge')
            ) {
              shouldRun = true;
              break;
            }
          }
        }

        if (shouldRun) break;
      }

      if (shouldRun) {
        // Re-apply fixes on the whole doc (safe + simple),
        // Yotpo markup is relatively small.
        fixYotpoAccessibility(document);
      }
    });

    observer.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true
    });
  });
})();


/* End - ADA fix Yotpo reviews section on product page */


/* Start - ADA fix rebuy smart cart clean up headings and price in airia */

(function () {
  function fixRebuyCartA11y() {
    // --- FIX 1: remove tabindex from the cart items <ul> ---
    document.querySelectorAll('ul[data-smartcart-items]').forEach(function (ul) {
      if (ul.hasAttribute('tabindex')) {
        ul.removeAttribute('tabindex');
      }
    });

    // --- FIX 2: make image links decorative ---
    document.querySelectorAll('.rebuy-cart__flyout-item-media a').forEach(function (link) {
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('tabindex', '-1');
      link.removeAttribute('aria-label');
    });

    // --- FIX 3: clean up tabindex on product title links ---
    document.querySelectorAll('.rebuy-cart__flyout-item-product-title').forEach(function (link) {
      if (link.getAttribute('tabindex') === '0') {
        link.removeAttribute('tabindex');
      }
    });

    // --- NEW: keep Checkout aria-label in sync with subtotal ---
    var amountEl = document.querySelector(
      '.rebuy-cart__flyout-subtotal-amount span:not(.sr-only)'
    );
    var checkoutBtn = document.querySelector('.rebuy-cart__checkout-button');

    if (checkoutBtn) {
      if (amountEl && amountEl.textContent.trim() !== '') {
        var amountText = amountEl.textContent.trim(); // e.g. "$52.52"
        checkoutBtn.setAttribute(
          'aria-label',
          'Checkout. Cart subtotal ' + amountText
        );
      } else {
        // If we can't find a subtotal, don't leave a stale aria-label
        checkoutBtn.removeAttribute('aria-label');
      }
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixRebuyCartA11y);
  } else {
    fixRebuyCartA11y();
  }

  // Re-run on Rebuy events
  document.addEventListener('rebuy:cart.change', fixRebuyCartA11y);
  document.addEventListener('rebuy:cart.show', fixRebuyCartA11y);

  // Backup safety watcher
  var observer = new MutationObserver(fixRebuyCartA11y);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();


/* End - ADA fix rebuy smart cart clean up headings and price in airia */

/* Start - ADA fix recharge prodcut page popup  */

(function () {
  function enhanceRechargeTooltips(root) {
    root = root || document;

    var containers = root.querySelectorAll('.rc-subscription-details');
    if (!containers.length) return;

    var isHoverDevice =
      window.matchMedia &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    containers.forEach(function (details) {
      var btn = details.querySelector('.rc-subscription-details__button');
      var tooltip = details.querySelector('.rc-tooltip');
      if (!btn || !tooltip) return;

      // Avoid double init
      if (btn.dataset.bbRechargeA11y === 'true') return;
      btn.dataset.bbRechargeA11y = 'true';

      // Ensure tooltip has an ID
      if (!tooltip.id) {
        tooltip.id = 'rc-tooltip-' + Math.random().toString(36).slice(2);
      }

      // ARIA baseline
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', tooltip.id);
      btn.setAttribute('aria-haspopup', 'dialog');
      tooltip.setAttribute('aria-hidden', 'true');
      tooltip.style.display = 'none';

      function openTooltip() {
        btn.setAttribute('aria-expanded', 'true');
        tooltip.setAttribute('aria-hidden', 'false');
        tooltip.style.display = 'block';
      }

      function closeTooltip() {
        btn.setAttribute('aria-expanded', 'false');
        tooltip.setAttribute('aria-hidden', 'true');
        tooltip.style.display = 'none';
      }

      function toggleTooltip() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          closeTooltip();
        } else {
          openTooltip();
        }
      }

      // CLICK / TAP
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (isHoverDevice) {
          // On desktop, click toggles but hover still works
          toggleTooltip();
        } else {
          // Touch: same behavior
          toggleTooltip();
        }
      });

      // KEYBOARD
      btn.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
          e.preventDefault();
          toggleTooltip();
        }
      });

      // --- DESKTOP HOVER BEHAVIOR WITH DELAY ---
      if (isHoverDevice) {
        var hideTimeout = null;

        function scheduleClose() {
          if (hideTimeout) clearTimeout(hideTimeout);
          hideTimeout = setTimeout(function () {
            closeTooltip();
            hideTimeout = null;
          }, 1000); // 1s grace
        }

        function cancelClose() {
          if (hideTimeout) {
            clearTimeout(hideTimeout);
            hideTimeout = null;
          }
        }

        // Open on hover over the button
        btn.addEventListener('mouseenter', function () {
          cancelClose();
          openTooltip();
        });

        // When leaving the button, *start* the delayed close
        btn.addEventListener('mouseleave', function () {
          scheduleClose();
        });

        // Moving into the tooltip cancels the pending close
        tooltip.addEventListener('mouseenter', function () {
          cancelClose();
        });

        // Leaving the tooltip starts the delayed close
        tooltip.addEventListener('mouseleave', function () {
          scheduleClose();
        });
      }

      // Focus alone should NOT open it; just ensure closed initially
      btn.addEventListener('focus', function () {
        closeTooltip();
      });

      // Click outside closes immediately
      document.addEventListener('click', function (e) {
        if (!details.contains(e.target) && btn.getAttribute('aria-expanded') === 'true') {
          closeTooltip();
        }
      });

      // If focus leaves the button+tooltip area, close it
      details.addEventListener('focusout', function (e) {
        if (!details.contains(e.relatedTarget)) {
          closeTooltip();
        }
      });
    });
  }

  function addPoweredByAria(root) {
    root = root || document;
    var badges = root.querySelectorAll('.recharge-badge');
    badges.forEach(function (badge) {
      if (!badge.getAttribute('aria-label')) {
        badge.setAttribute('aria-label', 'Powered by recharge');
      }
    });
  }

  function init(root) {
    enhanceRechargeTooltips(root);
    addPoweredByAria(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Watch for Recharge re-rendering the widget
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes && m.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;
        if (
          (node.matches && (node.matches('.rc-subscription-details') || node.matches('[id^="RechargeWidget_"]'))) ||
          (node.querySelector && node.querySelector('.rc-subscription-details'))
        ) {
          init(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();




/* End - ADA fix recharge prodcut page popup  */


/* Start - ADA fix video thumb from product page tab index  */


  (function () {
    // Remove tabindex from NON-interactive elements inside Plyr players
    function cleanPlyrTabindex(root) {
      if (!root) return;

      var tabbables = root.querySelectorAll('[tabindex]');
      tabbables.forEach(function (el) {
        var tag = (el.tagName || '').toLowerCase();
        var role = (el.getAttribute('role') || '').toLowerCase();

        // Native focusable elements we should NOT touch
        var isNativeFocusable =
          tag === 'button' ||
          tag === 'a' ||
          tag === 'input' ||
          tag === 'select' ||
          tag === 'textarea';

        // ARIA widgets that are meant to be focusable
        var isAriaWidget =
          role === 'button' ||
          role === 'link' ||
          role === 'tab' ||
          role === 'checkbox' ||
          role === 'radio' ||
          role === 'switch' ||
          role === 'slider' ||
          role === 'menuitem' ||
          role === 'option';

        // If it's not a native focusable and not an ARIA widget,
        // remove tabindex so it's not focusable.
        if (!isNativeFocusable && !isAriaWidget) {
          el.removeAttribute('tabindex');
        }
      });
    }

    function runCleanup() {
      // If Plyr is rendered directly in the page, this will catch it
      var plyrRoots = document.querySelectorAll('.plyr');
      plyrRoots.forEach(cleanPlyrTabindex);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runCleanup);
    } else {
      runCleanup();
    }

    // Optional: re-run if Plyr markup is injected later
    var observer = new MutationObserver(function () {
      runCleanup();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();



/* End - ADA fix video thumb from product page tab index  */



/* Start - ADA fix login page email not found error fix for ADA  */


  (function () {
    function fixLoginErrorMarkup() {
      var form = document.getElementById('customer_login');
      if (!form) return;

      var errorDiv = form.querySelector('.errors');
      if (!errorDiv) return;

      // Only touch it if it's still using a UL/LI
      var ul = errorDiv.querySelector('ul');
      if (!ul) return;

      var items = ul.querySelectorAll('li');
      // Only convert when there is a single error item
      if (items.length !== 1) return;

      var text = items[0].textContent.trim();
      if (!text) return;

      // Build the desired markup: <div><p>Incorrect email or password.</p></div>
      var wrapper = document.createElement('div');
      var p = document.createElement('p');
      p.textContent = text;
      wrapper.appendChild(p);

      // Replace the old list with our new structure
      errorDiv.innerHTML = '';
      errorDiv.appendChild(wrapper);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixLoginErrorMarkup);
    } else {
      fixLoginErrorMarkup();
    }
  })();


/* End - ADA fix login page email not found error fix for ADA  */


/* Start - ADA fix for featured products hide alt text on images since they are decorative  */



  (function () {
    function tweakFeaturedFlavorSlider() {
      // Target ONLY this featured collection slider
      var slider = document.querySelector(
        '#Slider-template--14416553214051__d305eb20-023f-4157-8a54-ede0b64f31e9'
      );
      if (!slider) return;

      /* 1) Make images decorative (per audit) */
      var imgs = slider.querySelectorAll('.card__media img');
      imgs.forEach(function (img) {
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('role', 'presentation');
      });

      /* 2) Convert the LOWER product titles from <h3> to <div> */
      var lowerHeadings = slider.querySelectorAll(
        'h3.card__heading.h5[id^="title-template--"]'
      );

      lowerHeadings.forEach(function (h3) {
        var div = document.createElement('div');

        // Copy all attributes from the h3 to the new div
        for (var i = 0; i < h3.attributes.length; i++) {
          var attr = h3.attributes[i];
          div.setAttribute(attr.name, attr.value);
        }

        // Copy inner HTML (link + text)
        div.innerHTML = h3.innerHTML;

        // Replace h3 with div in the DOM
        h3.parentNode.replaceChild(div, h3);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tweakFeaturedFlavorSlider);
    } else {
      tweakFeaturedFlavorSlider();
    }
  })();



/* End - ADA fix for featured products hide alt text on images since they are decorative  */

/* Start - ADA fix for product variant second buttons  */

  (function () {
    var SELECTED_COLOR = 'rgb(0, 87, 42)'; // your green

    function updateOptionGroup(group) {
      if (!group) return;

      var buttons = group.querySelectorAll('[role="button"][data-option-value]');
      if (!buttons.length) return;

      // First, normalize all labels back to just the option value
      buttons.forEach(function (btn) {
        var base = btn.getAttribute('data-option-value') || btn.textContent.trim();
        if (!base) return;
        base = base.replace(/\s+selected$/i, '');
        btn.setAttribute('aria-label', base);
      });

      // Then find the visually selected one (green background/border)
      var selectedBtn = null;
      buttons.forEach(function (btn) {
        var cs = window.getComputedStyle(btn);
        if (cs.backgroundColor === SELECTED_COLOR || cs.borderColor === SELECTED_COLOR) {
          selectedBtn = btn;
        }
      });

      if (selectedBtn) {
        var val = selectedBtn.getAttribute('data-option-value') || selectedBtn.textContent.trim();
        if (val) {
          selectedBtn.setAttribute('aria-label', val + ' selected');
        }
      }
    }

    function updateAllGroups(root) {
      var scope = root || document;
      var groups = scope.querySelectorAll('.rio-hide-scrollbar[data-option-type]');
      groups.forEach(updateOptionGroup);
    }

    // Initial pass
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        updateAllGroups();
      });
    } else {
      updateAllGroups();
    }

    // When user clicks a size/flavor option, update that group
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.rio-hide-scrollbar [role="button"][data-option-value]');
      if (!btn) return;
      var group = btn.closest('.rio-hide-scrollbar[data-option-type]');
      if (!group) return;

      // Let Rio update styles first
      setTimeout(function () {
        updateOptionGroup(group);
      }, 0);
    });

    // In case Rio re-renders options via JS, watch for mutations
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        var target = m.target;
        if (!target.closest) return;
        var group = target.closest('.rio-hide-scrollbar[data-option-type]');
        if (group) updateOptionGroup(group);
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  })();


/* End - ADA fix for product variant second buttons  */



/* Start - ADA fix for product variant buttons on product page   */


  (function () {
    function enhanceOptionLists() {
      // Find all Rio button-option groups (Size, Flavor, etc.)
      var groups = document.querySelectorAll('.rio-hide-scrollbar[data-option-type="button"]');
      if (!groups.length) return;

      groups.forEach(function (group) {
        // Avoid running twice
        if (group.dataset.ariaListApplied === 'true') return;

        // Mark the container as a list
        group.setAttribute('role', 'list');

        // Each direct grid item becomes a listitem
        var children = group.children;
        for (var i = 0; i < children.length; i++) {
          var child = children[i];
          if (child.classList && child.classList.contains('PwzrGrid-item-231')) {
            child.setAttribute('role', 'listitem');
          }
        }

        group.dataset.ariaListApplied = 'true';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enhanceOptionLists);
    } else {
      enhanceOptionLists();
    }

    // In case Shopify dynamically reloads sections
    document.addEventListener('shopify:section:load', enhanceOptionLists);
  })();



/* End - ADA fix for product variant buttons on product page   */


/* Start - ADA fix signup popup for first time   */


  (function () {
    function fixKlaviyoEmailPopupLabel() {
      // Limit to this specific popup form
      var form = document.querySelector('form[data-testid="klaviyo-form-WRQdWj"]');
      if (!form) return;

      var input = form.querySelector('input[type="email"][name="email"]');
      if (!input) return;

      // Avoid running twice
      if (input.dataset.bbAdaFixed === 'true') return;

      // Ensure the input has an id we can target with the label
      var id = input.id || ('kl_email_' + Date.now());
      input.id = id;

      // Remove aria-label per ADA request
      input.removeAttribute('aria-label');

// Remove placeholder (ADA prefers visible label instead)
input.placeholder = '';

      // Create a visible label
      var label = document.createElement('label');
      label.setAttribute('for', id);
      label.className = 'bb-kl-email-label';
      label.textContent = 'Email address';

      // Insert label right before the email input
      input.parentNode.insertBefore(label, input);

      input.dataset.bbAdaFixed = 'true';
    }

    // Run once on load
    document.addEventListener('DOMContentLoaded', fixKlaviyoEmailPopupLabel);

    // Run again whenever Klaviyo injects the popup into the DOM
    var obs = new MutationObserver(function () {
      fixKlaviyoEmailPopupLabel();
    });

    obs.observe(document.body, { childList: true, subtree: true });
  })();



/* End - ADA fix signup popup for first time   */



/* Start - ADA fix for  signup form improvement   */

// adds labels

  (function () {
    var FORM_SELECTOR = '.klaviyo-form-Vtd2QH form';

    function addLabel(input, text) {
      if (!input) return;

      // Avoid running twice
      if (input.dataset.adaLabelApplied === 'true') return;

      // Ensure input has an id
      var id = input.id || ('kl_' + text.replace(/\s+/g, '_').toLowerCase() + '_' + Date.now());
      input.id = id;

      // Remove aria-label per audit request
      input.removeAttribute('aria-label');

      // Optional: if you don't want placeholder text, uncomment:
       input.placeholder = '';

      // Check if label already exists
      var existing = input.parentElement.querySelector('label[for="' + id + '"]');
      if (!existing) {
        var label = document.createElement('label');
        label.setAttribute('for', id);
        label.className = 'kl-ada-label';
        label.textContent = text;

        // Insert label before the input
        input.parentElement.insertBefore(label, input);
      }

      input.dataset.adaLabelApplied = 'true';
    }

    function fixKlaviyoFormLabels() {
      var form = document.querySelector(FORM_SELECTOR);
      if (!form) return;

      // First name
      var firstName = form.querySelector('input[autocomplete="given-name"]');
      addLabel(firstName, 'First name');

      // Last name
      var lastName = form.querySelector('input[autocomplete="family-name"]');
      addLabel(lastName, 'Last name');

      // Email
      var email = form.querySelector('input[type="email"][name="email"]');
      addLabel(email, 'Email address');
    }

    document.addEventListener('DOMContentLoaded', function () {
      // Run repeatedly since Klaviyo loads async
      var tries = 0;
      var interval = setInterval(function () {
        fixKlaviyoFormLabels();
        tries++;
        if (tries > 20) clearInterval(interval);
      }, 500);
    });
  })();



/* End - ADA fix for  signup form improvement   */



/* Start - ADA fix for feature flavors screen reader improvement   */

  (function () {
    function fixSliderAria(root) {
      var sliderLists = root.querySelectorAll('ul[role="list"][aria-label="Slider"]');
      sliderLists.forEach(function (ul) {
        ul.removeAttribute('role');
        ul.removeAttribute('aria-label');
      });
    }

    // Run on initial load
    document.addEventListener('DOMContentLoaded', function () {
      fixSliderAria(document);
    });

    // Run again when Shopify dynamically loads sections (Dawn/2.0)
    document.addEventListener('shopify:section:load', function (event) {
      if (event && event.target) {
        fixSliderAria(event.target);
      }
    });
  })();



/* End - ADA fix for feature flavors screen reader improvement   */


/* Start - ADA fix for search preview products  */

(function () {
  function fixSnizeAccessibility() {
    // Remove aria-label from list items
    document.querySelectorAll('.snize-product[aria-label]').forEach(function (el) {
      el.removeAttribute('aria-label');
    });

    // Set empty alt attributes on product images
    document.querySelectorAll('.snize-item-image').forEach(function (img) {
      if (img.alt && img.alt.trim() !== '') {
        img.alt = '';
      }
    });
  }

  // Snize fires dynamic events — listen for results being updated
  document.addEventListener('snize:initialized', fixSnizeAccessibility);
  document.addEventListener('snize-results-updated', fixSnizeAccessibility);

  // Fallback timer (in case events don't fire)
  setInterval(fixSnizeAccessibility, 800);
})();


/* End - ADA fix for search preview products  */


/* Start - ADA fix for search hidden field  */


  (function () {
    function initSearchModalA11y() {
      var details = document.querySelector('.header__search details');
      if (!details) return;

      var modal = details.querySelector('.search-modal');
      if (!modal) return;

      var trigger = details.querySelector('.cm-header-search-button');

      function syncState() {
        var isOpen = details.hasAttribute('open');

        // Dialog visibility for screen readers
        if (isOpen) {
          modal.removeAttribute('aria-hidden');
        } else {
          modal.setAttribute('aria-hidden', 'true');
        }

        // Keep the trigger's aria-expanded accurate
        if (trigger) {
          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
      }

      // Run once on load
      syncState();

      // <details> fires "toggle" when opened/closed
      details.addEventListener('toggle', syncState);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSearchModalA11y);
    } else {
      initSearchModalA11y();
    }
  })();



/* End - ADA fix for search hidden field  */





/* Start - ADA fix for search icon  */

(function () {
  function enhanceHeaderSearch() {
    var detailsModal = document.querySelector('details-modal.header__search');
    if (!detailsModal) return;

    if (detailsModal.dataset.cmSearchFixed === 'true') return;

    var details = detailsModal.querySelector('details');
    if (!details) return;

    var summary = details.querySelector('summary.header__icon--search');
    if (!summary) return;

    // Avoid doing this twice
    if (summary.querySelector('button.cm-header-search-button')) {
      detailsModal.dataset.cmSearchFixed = 'true';
      return;
    }

    var span = summary.querySelector('span');
    if (!span) return;

    // Create a real button to hold the icons
    var button = document.createElement('button');
    button.type = 'button';
    button.className =
      'header__icon header__icon--search header__icon--summary link focus-inset cm-header-search-button';

    var ariaLabel = summary.getAttribute('aria-label') || 'Search';
    button.setAttribute('aria-label', ariaLabel);
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute(
      'aria-expanded',
      details.hasAttribute('open') ? 'true' : 'false'
    );

    // Move the SVGs into the button
    button.innerHTML = span.innerHTML;

    // Replace contents of summary with the button
    summary.innerHTML = '';
    summary.appendChild(button);

    // Strip interactive semantics from summary itself
    summary.removeAttribute('role');
    summary.removeAttribute('aria-label');
    summary.removeAttribute('aria-haspopup');
    summary.setAttribute('tabindex', '-1');

    // Keep aria-expanded in sync when details opens/closes
    details.addEventListener('toggle', function () {
      var isOpen = details.hasAttribute('open');
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    detailsModal.dataset.cmSearchFixed = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceHeaderSearch);
  } else {
    enhanceHeaderSearch();
  }
})();


/* End - ADA fix for search icon  */








/* Start - hide specific products from  add cart */


document.addEventListener('DOMContentLoaded', function () {
  // Replace with the product ID you want to target
  const targetProductId = 7933623173219;

  // Shopify exposes product.id on product templates
  const productIdElement = document.querySelector('[data-product-id]');
  const productId = productIdElement ? Number(productIdElement.dataset.productId) : null;

  if (productId === targetProductId) {
    // Hide add to cart button (covers all Dawn variations)
    const addToCartButtons = document.querySelectorAll(
      'product-form form[action="/cart/add"] button, ' +
      'form[action="/cart/add"] button, ' +
      'button[name="add"]'
    );

    addToCartButtons.forEach(btn => {
      btn.style.display = 'none';
    });
  }
});

/* End - hide specific products from  add cart */




/* Start - Ushop bundle redirects add to cart to smart cart for rebuy 
/* NO longer needed, uShop made a change for us so I disabled this here - CM

// uShopAid redirect override → send to cart + open Rebuy Smart Cart
(function () {
  if (!window.location || !window.location.assign || !window.location.replace) return;

  var originalAssign = window.location.assign.bind(window.location);
  var originalReplace = window.location.replace.bind(window.location);

  function rerouteCheckout(url) {
    try {
      // Normalize URL
      var a = document.createElement('a');
      a.href = url;

      var path = a.pathname || '';
      if (path === '/checkout') {
        // Instead of checkout, go to cart with a flag
        originalAssign('/cart?open_smartcart=1');
        return true; // handled
      }
    } catch (e) {
      console.warn('Checkout override error:', e);
    }
    return false;
  }

  window.location.assign = function (url) {
    if (!rerouteCheckout(url)) {
      return originalAssign(url);
    }
  };

  window.location.replace = function (url) {
    if (!rerouteCheckout(url)) {
      return originalReplace(url);
    }
  };
})();

// On cart page, auto-open Rebuy Smart Cart when returned from Mix & Match bundle
(function () {
  if (window.location.pathname !== '/cart') return;

  var params = new URLSearchParams(window.location.search || '');
  if (params.get('open_smartcart') !== '1') return;

  function openSmartCart() {
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
      window.Rebuy.SmartCart.show();
    } else {
      // If Rebuy isn't ready yet, try again shortly
      setTimeout(openSmartCart, 300);
    }
  }

  openSmartCart();
})();


/* End - Ushop bundle redirects add to cart to smart cart for rebuy */



/* Start - ADA improvement email signup field footer */


  (function () {
    function fixKlaviyoEmailLabel() {
      var wrapper = document.querySelector('.klaviyo-form-TfU27S');
      if (!wrapper) return;

      var form = wrapper.querySelector('form');
      if (!form) return;

      var input = wrapper.querySelector('input[type="email"][name="email"]');
      if (!input) return;

      // Avoid running twice
      if (input.dataset.labelApplied === 'true') return;

      // Ensure the input has an id
      var id = input.id || ('kl_email_' + Date.now());
      input.id = id;

      // Remove aria-label per ADA request (we'll use a proper <label>)
      input.removeAttribute('aria-label');

      // Put a normal placeholder back INSIDE the field
      if (!input.placeholder) {
        input.placeholder = 'EMAIL ADDRESS';
      }

      // Remove any inline border tweaks we added before
      input.style.border = '';

      // Create label if it doesn't exist
      var existingLabel = wrapper.querySelector('label[for="' + id + '"]');
      if (!existingLabel) {
        var label = document.createElement('label');
        label.setAttribute('for', id);
        label.className = 'kl-email-label sr-only';
        label.textContent = 'Email address';
        // Insert label before the input, but it will be visually hidden
        if (input.parentNode) {
          input.parentNode.insertBefore(label, input);
        }
      }

      input.dataset.labelApplied = 'true';
    }

    var observer = new MutationObserver(fixKlaviyoEmailLabel);
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('DOMContentLoaded', fixKlaviyoEmailLabel);
    window.addEventListener('load', fixKlaviyoEmailLabel);
  })();




/* End - ADA improvement email signup field footer  */


/* Start - ADA improvement on main nav quickify - 113025  */



  document.addEventListener('DOMContentLoaded', function () {
    // Target the mega-menu wrapper UL(s)
    var megaMenus = document.querySelectorAll(
      'ul.tmenu_submenu_type_mega.tmenu_submenu--desktop.tmenu_submenu_mega_position_fullwidth.tmenu_submenu'
    );

    megaMenus.forEach(function (ul) {
      // Make the outer UL purely presentational (no list semantics)
      ul.setAttribute('role', 'presentation');
      // Some auditors prefer role="none" - this is equivalent for AT
      // ul.setAttribute('role', 'none');

      // Remove any list-related ARIA that might exist
      ul.removeAttribute('aria-label');
      ul.removeAttribute('aria-labelledby');

      // Make each *top-level* LI presentational too
      Array.prototype.forEach.call(ul.children, function (child) {
        if (child.tagName === 'LI') {
          child.setAttribute('role', 'none');
          // Also clear any accidental group/list roles if present
          child.removeAttribute('role'); // then re-set to none
          child.setAttribute('role', 'none');
        }
      });
    });
  });







  (function () {
    function fixMenuHeadings() {
      var navHeadings = document.querySelectorAll(
        '.tmenu_submenu_type_mega [role="heading"][aria-level]'
      );
      navHeadings.forEach(function (el) {
        el.setAttribute('aria-level', '2');
      });
    }

    // Run once on DOM ready
    document.addEventListener('DOMContentLoaded', fixMenuHeadings);

    // Run again when everything (including scripts) has loaded
    window.addEventListener('load', fixMenuHeadings);

    // Extra: poll a few times in case the menu is injected late
    var tries = 0;
    var interval = setInterval(function () {
      fixMenuHeadings();
      tries++;
      if (tries > 20) {
        clearInterval(interval);
      }
    }, 500);
  })();





/* End - ADA improvement on main nav quickify - 113025  */



/* Start - ADA improvement on site search allows keyboard to search results dropdown */

document.addEventListener('DOMContentLoaded', function () {
  var modal      = document.querySelector('.search-modal[role="dialog"]');
  var modalInner = document.querySelector('.search-modal__content');
  var searchInput = document.getElementById('Search-In-Modal');

  // --- 1) Make sure Searchanise results live inside the modal content ---
  function moveSnizeIntoModal() {
    var snizeResults = document.getElementById('snize-instant-search-results');
    if (modalInner && snizeResults && !modalInner.contains(snizeResults)) {
      modalInner.appendChild(snizeResults);
    }
  }

  var modalObserver = new MutationObserver(function () {
    moveSnizeIntoModal();
  });
  modalObserver.observe(document.body, { childList: true, subtree: true });
  moveSnizeIntoModal();

  // --- 2) From search input, ArrowDown jumps to first result (including "More") ---
  if (searchInput) {
    searchInput.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown') return;

      var firstResult = document.querySelector(
        '#snize-instant-search-results [tabindex="0"], ' +
        '#snize-instant-search-results a[href], ' +
        '#snize-instant-search-results button:not([disabled])'
      );

      if (firstResult) {
        event.preventDefault();
        firstResult.focus();
      }
    });
  }

  // --- 3) Tab from the close button -> first result ---
  var closeButton = document.querySelector('.search-modal__close-button');
  if (closeButton) {
    closeButton.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && !event.shiftKey) {
        var firstResult = document.querySelector(
          '#snize-instant-search-results [tabindex="0"], ' +
          '#snize-instant-search-results a[href], ' +
          '#snize-instant-search-results button:not([disabled])'
        );

        if (firstResult) {
          event.preventDefault();
          event.stopPropagation();
          firstResult.focus();
        }
      }
    });
  }

  // --- 4) Trap focus inside the dialog ---
  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), ' +
        'select:not([disabled]), textarea:not([disabled]), ' +
        '[tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return el.offsetParent !== null && el.getAttribute('aria-hidden') !== 'true';
    });
  }

  if (modal) {
    modal.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;

      var focusables = getFocusableElements(modal);
      if (!focusables.length) return;

      var first = focusables[0];
      var last  = focusables[focusables.length - 1];
      var active = document.activeElement;

      if (event.shiftKey) {
        if (active === first) {
          event.preventDefault();
          last.focus();
        }
      } else {
        if (active === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }
});

/* End - ADA improvement on site search allows keyboard to search results dropdown */


/* Start - ADA improvement on site search headings (Pages / Products outside list) */

function fixSearchaniseHeadings() {
  [
    { id: 'snize-pages-label',    fallbackText: 'Pages' },
    { id: 'snize-products-label', fallbackText: 'Products' }
  ].forEach(function (cfg) {
    var id   = cfg.id;
    var text = cfg.fallbackText;

    // If we already have an <h2> for this label, just make sure it's not aria-hidden and bail
    var existingHeading = document.querySelector('h2#' + id);
    if (existingHeading) {
      existingHeading.removeAttribute('aria-hidden');
      return;
    }

    // Look for the original <li id="snize-*-label">
    var li = document.querySelector('li#' + id);
    if (!li) return;

    var ul = li.closest('ul');
    if (!ul || !ul.parentNode) return;

    // Create a proper <h2> heading outside the <ul>
    var h2 = document.createElement('h2');
    h2.id        = id;
    h2.className = li.className || 'snize-label';
    h2.textContent = (li.textContent || '').trim() || text;
    h2.removeAttribute('aria-hidden');

    // Insert <h2> before the list and remove the <li> heading
    ul.parentNode.insertBefore(h2, ul);
    li.remove();

    // Ensure the list is labelled by this heading
    ul.setAttribute('aria-labelledby', id);
  });
}

// Run once immediately
fixSearchaniseHeadings();

// Run again whenever Searchanise updates the DOM
var headingsObserver = new MutationObserver(function () {
  fixSearchaniseHeadings();
});
headingsObserver.observe(document.body, { childList: true, subtree: true });

/* End - ADA improvement on site search headings */


/* Start - ADA improvement on site search "More" / "View all" links */

function fixSearchaniseMoreLinks() {
  // These are the "More pages" / "View all X items" controls Searchanise outputs as fake buttons
  var moreItems = document.querySelectorAll('#snize-view-all-link, #snize-view-all-pages');

  moreItems.forEach(function (li) {
    if (!li || li.dataset.fixed === 'true') return;

    // Make sure we're working with the <li>, not an <a> we already injected
    if (li.tagName.toLowerCase() !== 'li') return;

    // Save the original classes so we can move them to the <a>
    var originalClasses = li.className;

    // Get current search query from the search input (if present)
    var input = document.querySelector('.search__input');
    var query = input ? encodeURIComponent(input.value) : '';

    // Build a new anchor
    var link = document.createElement('a');
    link.href = '/pages/search-results-page?q=' + query;
    link.className = originalClasses; // all styling lives on the <a>, not the <li>

    // aria-label: More pages or More products
    var ariaLabel = (li.id === 'snize-view-all-pages') ? 'More pages' : 'More products';
    link.setAttribute('aria-label', ariaLabel);
    link.setAttribute('role', 'link');

    // Move existing child nodes (text, span, icon) inside the anchor
    while (li.firstChild) {
      link.appendChild(li.firstChild);
    }

    // Clear the li and insert our new anchor
    li.innerHTML = '';
    li.appendChild(link);

    // Make the <li> a neutral wrapper so it doesn't get button styling
    li.className = 'snize-view-all-wrapper';
    li.removeAttribute('role');
    li.removeAttribute('tabindex');

    // Mark as fixed so we don't re-wrap on future mutations
    li.dataset.fixed = 'true';
  });
}

// Run once immediately
fixSearchaniseMoreLinks();

// Observe DOM (Searchanise rewrites HTML constantly)
var snzMoreObserver = new MutationObserver(function () {
  fixSearchaniseMoreLinks();
});
snzMoreObserver.observe(document.body, { childList: true, subtree: true });

/* End - ADA improvement on site search "More" / "View all" links */



/* Start - ADA improvement on product page thumbs   */


// console.log('[carousel a11y] script tag loaded');
(function () {
  function enhanceCarouselA11y() {
    console.log('[carousel a11y] enhanceCarouselA11y() called');

    var container = document.querySelector('.pwzrswiper-container');
    if (!container) {
      console.log('[carousel a11y] no .pwzrswiper-container yet');
      return false;
    }

    // Region + live area
    container.setAttribute('role', 'region');
    container.setAttribute('aria-label', 'Product image carousel');
    container.setAttribute('aria-live', 'polite');
    console.log('[carousel a11y] aria attributes applied');

/* ============================================
   ARROW LABELING (Previous / Next slide)
   ============================================ */
var iconButtons = document.querySelectorAll('.PwzrIconButton-root[role="button"]');

if (iconButtons.length === 1) {
  // Only one arrow visible – make it "Next slide"
  iconButtons[0].setAttribute('aria-label', 'Next slide');
} else {
  iconButtons.forEach(function (btn, index) {
    btn.setAttribute('aria-label', index === 0 ? 'Previous slide' : 'Next slide');
  });
}


    /* ============================================
       SELECTED THUMBNAIL LABEL + ARIA-PRESSED
       ============================================ */
    var thumbButtons = document.querySelectorAll('.pwzrjss5[role="button"]');

    if (thumbButtons.length === 0) {
      return iconButtons.length > 0; // we found arrows but no thumbs yet
    }

    // Helper to set ARIA state for all thumbs
    function updateThumbA11y(activeBtn) {
      thumbButtons.forEach(function (btn) {
        var existing = btn.querySelector('.carousel-sr-only');
        if (existing) existing.remove();

        var style = btn.getAttribute('style') || '';
        var isSelected;

        if (activeBtn) {
          // When called after a click, trust the button we were passed
          isSelected = (btn === activeBtn);
        } else {
          // Initial pass: detect selected based on black border
          isSelected = /border:\s*1px\s*solid\s*rgb\s*\(\s*0\s*,\s*0\s*,\s*0\s*\)/i.test(style);
        }

        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

        if (isSelected) {
          var sr = document.createElement('span');
          sr.className = 'carousel-sr-only';
          sr.textContent = 'Selected';
          btn.appendChild(sr);
        }
      });
    }

    // Initial state (based on border)
    updateThumbA11y();

    // Keep ARIA in sync when a thumb is activated
    thumbButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateThumbA11y(this);
      });
    });

    // We’re “done” once both arrows and thumbs exist
    return iconButtons.length > 0 && thumbButtons.length > 0;
  }

  function initWithPolling() {
    console.log('[carousel a11y] starting polling');
    var tries = 0;
    var maxTries = 40;

    var interval = setInterval(function () {
      tries++;
      var ok = enhanceCarouselA11y();

      if (ok || tries >= maxTries) {
        clearInterval(interval);
        console.log('[carousel a11y] stopping polling, success = ' + ok);
      }
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWithPolling);
  } else {
    initWithPolling();
  }
})();




/* End - Start - ADA improvement on product page thumbs */



/* Start - Yotpo reviews tab ADA improvement  */




(function () {
  function enhanceYotpoTabs(root) {
    var tablists = (root || document).querySelectorAll('.yotpo-nav-primary ul[role="tablist"]');
    tablists.forEach(function (tablist) {
      var liTabs = tablist.querySelectorAll('li.yotpo-nav-tab');

      liTabs.forEach(function (li, index) {
        // Skip if already enhanced
        if (li.querySelector('button.yotpo-tab-button')) return;

        var controlsId = li.getAttribute('aria-controls') || li.getAttribute('data-content');
        var isActive   = li.classList.contains('yotpo-active');

        // Remove tab semantics from <li> and make it presentational
        li.removeAttribute('role');
        li.removeAttribute('aria-selected');
        li.removeAttribute('tabindex');
        li.setAttribute('role', 'presentation');

        // Create the button that will actually be the tab
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'yotpo-tab-button';
        btn.setAttribute('role', 'tab');

        var tabId = (controlsId ? controlsId + '-tab' : 'yotpo-tab-' + index);
        btn.id = tabId;

        if (controlsId) {
          btn.setAttribute('aria-controls', controlsId);
        }

        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');

        // Move existing contents into the button
        while (li.firstChild) {
          btn.appendChild(li.firstChild);
        }
        li.appendChild(btn);

        // Mark the associated panel as a tabpanel and link it back
        if (controlsId) {
          var panel = document.getElementById(controlsId);
          if (panel) {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', tabId);
          }
        }
      });

      var buttons = tablist.querySelectorAll('button.yotpo-tab-button');

      function syncTabs() {
        buttons.forEach(function (btn) {
          var li = btn.closest('li');
          var isActive = li && li.classList.contains('yotpo-active');
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
          btn.setAttribute('tabindex', isActive ? '0' : '-1');
        });
      }

      buttons.forEach(function (btn) {
        // After Yotpo switches tabs (via classes), update ARIA
        btn.addEventListener('click', function () {
          setTimeout(syncTabs, 0);
        });

        // Left/Right arrow key navigation between tabs
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var currentIndex = Array.prototype.indexOf.call(buttons, btn);
            var delta = e.key === 'ArrowRight' ? 1 : -1;
            var newIndex = (currentIndex + delta + buttons.length) % buttons.length;
            buttons[newIndex].click();   // activate tab (Yotpo logic)
            buttons[newIndex].focus();   // move focus
          }
        });
      });

      syncTabs();
    });
  }

  // Run once when DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    enhanceYotpoTabs();

    // Also watch for Yotpo injecting/re-rendering content
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.addedNodes && m.addedNodes.length) {
          enhanceYotpoTabs();
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();





/* End - Yotpo reviews tab ADA improvement  */




/* Start - recharge tooltip fix  */

  document.addEventListener('DOMContentLoaded', function () {
    var LABEL_TEXT = 'Learn more about How subscriptions work';

    function addAriaLabelToRechargeLearnMore() {
      var links = document.querySelectorAll('.rc-tooltip a.learn-more');

      links.forEach(function (link) {
        if (!link.hasAttribute('aria-label')) {
          link.setAttribute('aria-label', LABEL_TEXT);
        }
      });
    }

    // Run once on load
    addAriaLabelToRechargeLearnMore();

    // Watch for dynamically injected tooltips/links
    var observer = new MutationObserver(function (mutations) {
      // If any new nodes are added, try again
      var shouldRun = mutations.some(function (m) { return m.addedNodes.length > 0; });
      if (shouldRun) {
        addAriaLabelToRechargeLearnMore();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });



/* End - recharge tooltip fix  */




/* Start - Product size and flavor variants ADA improvement  */

// adds flavor selected as text
// Give Rio option titles proper heading semantics without changing the DOM tag – CM
(function () {
  function markRioOptionHeadings() {
    document
      .querySelectorAll('.rio-product-option-title:not([data-aria-heading])')
      .forEach(function (el) {
        el.setAttribute('role', 'heading');
        el.setAttribute('aria-level', '2'); // H2 under product H1
        el.setAttribute('data-aria-heading', 'true');
      });
  }

  document.addEventListener('DOMContentLoaded', markRioOptionHeadings);

  // If Rio re-renders options later (variant change, etc.), mark new ones too
  new MutationObserver(function (mutations) {
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        markRioOptionHeadings();
        break;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();





/* End - Product size and flavor variants ADA improvement  */


/* Start - Yotpo ADA improvements on stars */

// Yotpo ADA enhancement – CM
(function () {
  function fixYotpoRatings() {
    var starsEls = document.querySelectorAll('.yotpo-stars:not([data-ada-fixed])');

    starsEls.forEach(function (starsEl) {
      var sr = starsEl.querySelector('.sr-only');
      if (!sr) return;

      // Get text like "4.5 star rating"
      var ratingText = sr.textContent.trim();
      if (!ratingText) return;

      // Create visible text node after the stars
     var textSpan = document.createElement('span');
      textSpan.className = 'yotpo-rating-text';
  textSpan.textContent = " (" + ratingText + ") ";

      // Insert after the stars container
      starsEl.parentNode.insertBefore(textSpan, starsEl.nextSibling);

      // Make the star icons decorative for AT
      starsEl.setAttribute('aria-hidden', 'true');

      // Avoid processing this again
      starsEl.setAttribute('data-ada-fixed', 'true');
    });
  }

  // Run once now, and again whenever Yotpo injects content
  document.addEventListener('DOMContentLoaded', function () {
    fixYotpoRatings();

    // Handle widgets loaded later by Yotpo
    var observer = new MutationObserver(fixYotpoRatings);
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();


// additional fix starts

// Yotpo ADA enhancement for bottomline link – CM
(function () {
  function enhanceYotpoBottomlines() {
    document
      .querySelectorAll('.yotpo-bottomline.star-clickable:not([data-ada-enhanced])')
      .forEach(function (el) {
        // --- Get rating text from sr-only ---
        var sr = el.querySelector('.sr-only');
        var ratingText = sr ? sr.textContent.trim() : "";

        // --- Get review count from <a> ---
        var reviewLink = el.querySelector('a.text-m');
        var reviewText = reviewLink ? reviewLink.textContent.trim() : "";
        var numReviews = reviewText.replace(/[^\d]/g, "").trim(); // "63 Reviews" -> "63"

        if (!ratingText || !numReviews) return;

        // --- Build full aria-label: "4.5 star rating with 63 Reviews" ---
        var fullLabel = ratingText + " with " + numReviews + " Reviews";

        el.setAttribute("role", "link");
        el.setAttribute("aria-label", fullLabel);
        el.setAttribute("tabindex", "0");

        // --- Add visible "63 Reviews" text (not a link) ---
        var visibleSpan = document.createElement("span");
        visibleSpan.className = "yotpo-review-count text-m";
        visibleSpan.textContent = numReviews + " Reviews";

        // Insert after the rating text span if present, else before the clear div
        var ratingTextSpan = el.querySelector(".yotpo-rating-text");
        var clr = el.querySelector(".yotpo-clr");
        if (ratingTextSpan) {
          ratingTextSpan.insertAdjacentElement("afterend", visibleSpan);
        } else if (clr) {
          el.insertBefore(visibleSpan, clr);
        } else {
          el.appendChild(visibleSpan);
        }

  
     // --- Remove the original <a> to satisfy ADA request ---
if (reviewLink) {
  reviewLink.remove();
}


        // --- Keyboard: make Enter/Space activate the same click as mouse ---
        el.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            el.click(); // Yotpo usually binds click on this container
          }
        });

        el.setAttribute("data-ada-enhanced", "true");
      });
  }

  document.addEventListener("DOMContentLoaded", enhanceYotpoBottomlines);
  new MutationObserver(enhanceYotpoBottomlines).observe(document.body, {
    childList: true,
    subtree: true
  });
})();


/* End  - Yotpo ADA improvements on stars */



/* Start - Collection filters improvement ADA */
// ADA: add headings for collection filter groups
(function () {
  function getFilterLabelText(summaryEl) {
    if (!summaryEl) return '';

    // Dawn usually has: <summary><div><span>Label<span class="facets__selected"> (0)</span></span>...</div></summary>
    var labelSpan = summaryEl.querySelector('div > span');

    if (labelSpan && labelSpan.firstChild && labelSpan.firstChild.nodeType === Node.TEXT_NODE) {
      return labelSpan.firstChild.textContent.trim();
    }

    // Fallback: strip "(0 selected)" etc from full text
    return summaryEl.textContent.replace(/\(\s*\d+\s*selected\s*\)/i, '').trim();
  }

  function addDesktopFacetHeadings() {
    document.querySelectorAll('facet-filters-form .js-filter').forEach(function (detailsEl) {
      var summary = detailsEl.querySelector('summary');
      if (!summary) return;

      // Don’t run twice
      var prev = summary.previousElementSibling;
      if (prev && prev.classList.contains('facets__group-heading')) return;

      var labelText = getFilterLabelText(summary);
      if (!labelText) return;

      var h = document.createElement('h3');
      h.className = 'facets__group-heading visually-hidden';
      h.textContent = labelText;

      detailsEl.insertBefore(h, summary);
    });
  }

  function addMobileFacetHeadings() {
    // Mobile filter drawer version
    document.querySelectorAll('.mobile-facets__inner details.js-filter').forEach(function (detailsEl) {
      var summary = detailsEl.querySelector('.mobile-facets__summary, summary');
      if (!summary) return;

      var prev = summary.previousElementSibling;
      if (prev && prev.classList.contains('mobile-facets__group-heading')) return;

      var labelText = getFilterLabelText(summary);
      if (!labelText) return;

      var h = document.createElement('h3');
      h.className = 'mobile-facets__group-heading visually-hidden';
      h.textContent = labelText;

      detailsEl.insertBefore(h, summary);
    });
  }

  function enhanceFacetHeadings() {
    // Only run on pages that actually have facets
    if (!document.querySelector('facet-filters-form')) return;

    addDesktopFacetHeadings();
    addMobileFacetHeadings();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceFacetHeadings);
  } else {
    enhanceFacetHeadings();
  }
})();

/* End - Collection filters improvement ADA */



/* Start - ADA rebuy smart cart products improvement */


(function () {
  function enhanceRebuyCartItems() {
    // Find the Smart Cart items list
    var cartLists = document.querySelectorAll('[data-rebuy-component="cart-items"] ul[data-smartcart-items]');
    if (!cartLists.length) return;

    cartLists.forEach(function (ul) {
      // Remove role="group" (ADA request)
      if (ul.getAttribute('role') === 'group') {
        ul.removeAttribute('role');
      }

      // Remove aria-label="product" from <li> items
      ul.querySelectorAll('li[aria-label]').forEach(function (li) {
        li.removeAttribute('aria-label');
      });

      // For each product title link, remove heading roles and wrap in <h3>
      ul.querySelectorAll('.rebuy-cart__flyout-item-product-title').forEach(function (link) {
        // Remove ARIA heading stuff
        if (link.getAttribute('role') === 'heading') {
          link.removeAttribute('role');
        }
        if (link.hasAttribute('aria-level')) {
          link.removeAttribute('aria-level');
        }

        // If it's already inside an <h3>, don't do anything
        if (link.closest('h3')) return;

        // Create <h3> and move the link inside it
        var h3 = document.createElement('h3');
        h3.className = 'rebuy-cart__flyout-item-product-title-heading';

        // Insert <h3> where the link currently sits, then move the link into it
        link.parentNode.insertBefore(h3, link);
        h3.appendChild(link);
      });
    });
  }

  function safeEnhanceCartItems() {
    try {
      enhanceRebuyCartItems();
    } catch (e) {
      console.error('ADA: error enhancing Rebuy cart items', e);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Run once on load
    safeEnhanceCartItems();

    // Re-run whenever Rebuy updates the cart DOM
    var observer = new MutationObserver(function () {
      safeEnhanceCartItems();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();



/* End - ADA rebuy smart cart products improvement */


// Start - rebuy smart cart ADA improvement for gift area and product\\

(function () {
  function enhanceRebuyNotes() {
    var notesComponent = document.querySelector('[data-rebuy-component="notes"]');
    if (!notesComponent) return;

   // console.log('ADA: enhancing Rebuy notes');

    var checkbox     = notesComponent.querySelector('.rebuy-cart__notes-toggle-input');
    var labelSpan    = notesComponent.querySelector('.rebuy-cart__notes-toggle-label');
    var notesContent = notesComponent.querySelector('.rebuy-cart__notes-content');
    var textarea     = notesComponent.querySelector('#rebuy-cart__notes');
    var counter      = notesComponent.querySelector('#rebuy-cart-characters-remaining');

    // 1) Label the textarea with the visible "Gift Message (optional)" text
    if (labelSpan && textarea) {
      if (!labelSpan.id) {
        labelSpan.id = 'rebuy-notes-label';
      }
      textarea.setAttribute('aria-labelledby', labelSpan.id);
    }

    // 2) Make checkbox act as a disclosure control for the notes content
    if (checkbox && notesContent) {
      if (!notesContent.id) {
        notesContent.id = 'rebuy-notes-content';
      }

      checkbox.setAttribute('aria-controls', notesContent.id);

      var syncDisclosureState = function () {
        var expanded = checkbox.checked;
        checkbox.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        notesContent.setAttribute('aria-hidden', expanded ? 'false' : 'true');
      };

      // Run once now and again on change
      syncDisclosureState();
      checkbox.removeEventListener('change', syncDisclosureState); // safe no-op first time
      checkbox.addEventListener('change', syncDisclosureState);
    }

    // 3) Character counter – make it a polite live region
    if (counter) {
      counter.setAttribute('aria-live', 'polite');
      counter.setAttribute('role', 'status');
    }

    // 4) Subtotal + Checkout button
    var subtotalAmount = document.querySelector(
      '[data-rebuy-component="cart-subtotal"] .rebuy-cart__flyout-subtotal-amount span:not(.sr-only)'
    );
    var checkoutBtn = document.querySelector('.rebuy-cart__checkout-button');

    if (subtotalAmount && checkoutBtn && !checkoutBtn.hasAttribute('aria-label')) {
      var amountText = subtotalAmount.textContent.trim();
      checkoutBtn.setAttribute('aria-label', 'Checkout. Cart subtotal ' + amountText);
    }

    // 5) Continue shopping button
    var continueBtn = document.querySelector('.rebuy-cart__continue-shopping-button');
    if (continueBtn && !continueBtn.hasAttribute('aria-label')) {
      continueBtn.setAttribute('aria-label', 'Continue shopping');
    }
  }

  function safeEnhance() {
    try {
      enhanceRebuyNotes();
    } catch (e) {
      console.error('ADA: error enhancing Rebuy notes', e);
    }
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', function () {
    safeEnhance();

    // Re-run when DOM changes (Rebuy injection / updates)
    var observer = new MutationObserver(function () {
      safeEnhance();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();







// End - rebuy smart cart ADA improvement for gift area \\



//////////////////////////////////////////////////////////////
// Start - shows video transcript on product pages carasoul //

// Variant Wizard / Rio video transcript injection - v2 (safer placement + broader selectors)
(function () {
  function isRioVideoIframe(frame) {
    if (!frame) return false;
    var src = frame.getAttribute('src') || '';
    return src.includes('pwzcdn.com/rio-store/prod/video-player/');
  }

  function processIframe(frame) {
    if (!frame || frame.dataset.transcriptApplied === 'true') return;
    if (!isRioVideoIframe(frame)) return;

    var transcriptText = frame.getAttribute('title');
    if (!transcriptText) return;

    var panelId = 'video-transcript-' + Math.random().toString(36).slice(2);

    // Wrapper
    var wrapper = document.createElement('div');
    wrapper.className = 'video-transcript-wrapper';

    // Button
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'video-transcript-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', panelId);
    btn.textContent = 'Show video transcript';

    // Panel
    var panel = document.createElement('div');
    panel.id = panelId;
    panel.className = 'video-transcript-panel';
    panel.hidden = true;
    panel.textContent = transcriptText;

    wrapper.appendChild(btn);
    wrapper.appendChild(panel);

    // --- Placement (IMPORTANT CHANGE) ---
    // Put transcript *after* the gallery container so it doesn't get clipped by internal overflow/layout.
    var mediaRoot = frame.closest('.rio-media-gallery');
    var placeAfter = mediaRoot || frame.closest('.product__media-wrapper') || frame.parentElement;

    if (placeAfter && placeAfter.parentElement) {
      placeAfter.insertAdjacentElement('afterend', wrapper);
    } else {
      frame.insertAdjacentElement('afterend', wrapper);
    }

    // Accessibility: connect transcript to iframe
    var existing = (frame.getAttribute('aria-describedby') || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    if (!existing.includes(panelId)) {
      existing.push(panelId);
      frame.setAttribute('aria-describedby', existing.join(' '));
    }

    // Toggle
    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
      btn.textContent = isOpen ? 'Show video transcript' : 'Hide video transcript';
    });

    // Only show when the video slide is active
    var slideEl = frame.closest('.pwzrswiper-slide');

    function hideOrShow() {
      if (slideEl && slideEl.classList.contains('pwzrswiper-slide-active')) {
        wrapper.style.display = 'block';
      } else {
        wrapper.style.display = 'none';
      }
    }

    if (slideEl) {
      hideOrShow();
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'class') hideOrShow();
        }
      });
      observer.observe(slideEl, { attributes: true, attributeFilter: ['class'] });
    } else {
      wrapper.style.display = 'block';
    }

    frame.dataset.transcriptApplied = 'true';
  }

  function scanForIframes() {
    // Broader: any iframe with a title + src containing Rio video player
    var frames = document.querySelectorAll('iframe[title][src*="pwzcdn.com/rio-store/prod/video-player/"]');
    frames.forEach(processIframe);
  }

  function initTranscriptWatcher() {
    scanForIframes();

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches && node.matches('iframe[title][src*="pwzcdn.com/rio-store/prod/video-player/"]')) {
            processIframe(node);
            return;
          }

          if (node.querySelectorAll) {
            var inner = node.querySelectorAll('iframe[title][src*="pwzcdn.com/rio-store/prod/video-player/"]');
            inner.forEach(processIframe);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTranscriptWatcher);
  } else {
    initTranscriptWatcher();
  }
})();



//  End - swatches ADA fix to make selectable on featured colelctions - cm //
// End - shows video transcript on product pages carasoul //
/////////////////////////////////////////////////////////////////////////////



function assign_gift_message_btn() {
//  fixes aria-lable on gift message

  //console.log("ssssssssssssss"); 
  
  var z = document.getElementsByClassName("icart-new-lab-bor");
  var iii;
  for (iii = 0; iii < z.length; iii++) {

    if (z[iii].hasAttribute("data-key")) {
       z[iii].setAttribute("aria-label", "enter gift message below"); // updates aria-lable
       z[iii].setAttribute("aria-hidden", "true"); // updates aria-lable
      // z[iii].setAttribute("aria-selected", "false"); // updates aria-lable
      
   //   z[iii].setAttribute("title", "activate to show enlarged image"); // adds H2 to the main menu items
}  // end if

    

  }
} // end function


function assign_product_img_instructions() {
//  This assigns more instructions to product images on product page - CM

  var x = document.getElementsByClassName("pwzrjss5");
  var i;
  for (i = 0; i < x.length; i++) {
 
    if (x[i].hasAttribute("role")) {
       x[i].setAttribute("id", "product_image_id" + i); // adds H2 to the main menu items 
      x[i].setAttribute("title", "activate to show enlarged image"); // adds H2 to the main menu items
}  // end if


   

  }
} // end function

function assign_product_img_instructions_img() {
//  This assigns more instructions to product images on product page - CM


    var xx = document.getElementsByClassName("pwzrjss3");
  var ii;
  for (ii = 0; ii < xx.length; ii++) {
 
    if (xx[ii].hasAttribute("src")) {
      xx[ii].setAttribute("aria-labelledby", "product_image_id" + ii); // adds H2 to the main menu items
}  // end if

    


    

  }
} // end function




function assign_headers_to_nav() {
// This assigns instructions to header items that are collapsable like  main nav item  Shop, about Safety - CM

  
 //  console.log("yyyyyyyyyyyyyyyyyyyyyy"); 

  
  var x = document.getElementsByClassName("header__menu-item");
  var i;
  for (i = 0; i < x.length; i++) {
 //   console.log(x[i]);
 //  console.log("88888888888888888"); 
    
    // x[i].setAttribute("role", "heading");  // adds H2 to the main menu items


    if (x[i].hasAttribute("aria-expanded")) {
 // element.setAttribute("target", "_self");

      
           x[i].setAttribute("aria-label", "to activate press enter"); // adds H2 to the main menu items
    
  //  x[i].setAttribute("aria-required", "true");
}  // end if

    

  }
} // end function



document.addEventListener("DOMContentLoaded", function() {
    // code here 
  
  //assign_headers_to_nav(); 

  // Delays the function so nav can load, better andcorrect way is to wait for qikify's function. They said: You can listen for the event "smartmenu-loaded". - CM
  setTimeout(assign_headers_to_nav, 3000);
  setTimeout(assign_product_img_instructions, 3000);
  setTimeout(assign_product_img_instructions_img, 3000);
setTimeout(assign_gift_message_btn, 3000);
  
  });
 




// Start - Press enter to assign aria info on nav //

$( document ).ready(function() {
    // console.log( "ready!" );


  $(".link--text focus-inset").keypress(function(){
    // console.log("dddddddddddddddddddddd"); 
  
  //$("span").text(i += 1);
});


 
});  // end onready()




// End - Press enter to assign aria info on nav //


